import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionTokenService } from '../../../session/service/session-token';

@Injectable()
export class SessionTokenGuard implements CanActivate {

  constructor(private sessionService: SessionTokenService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.sessionService.isAuthenticated()) {
      return true;
    }
    this.router.navigate([ '/login' ]);
    return false;
  }
}
